import { HomeState } from '@shared/redux/state/homeState';
import { getBrowserSupport } from '@shared/util/browserDetector';

export const getInitHomeState = (): HomeState => ({
  udiCompanyIdentifier: '',
  stageVersion: '',
  newVersionReleased: false,
  allowToWorkWithBrowser: getBrowserSupport(),
});
